// Utils
import { assert } from 'ezyvet-fe-helpers';
import { objectIdGenerationState } from './objectIdGenerationState';
/**
 * Used to set the primary object identity generator, if this generator return null or is not defined then
 * a fallback method is used.
 *
 * This was added to ensure there is nothing ezyVet specific(previously was assuming the presence of
 * `_class` and `id`). Now this can be generalised to any object structure to extract a unique id
 * for object comparison.
 *
 * Without defining this every object will just be assigned it's own unique id in the form of
 * `UID_{someUniqueNumber}`
 *
 * @todo we might want to have this passed through associated functions instead of setting globally,
 * will need to see how this will effect the method signatures outside of identify and
 * identifyAndCommit. Eventually for a more reusable solution decoupling the identifying records
 * from grabbing an objects identity would be the end goal. Then we could split each up into their
 * own packages and allow for other mechanisms that other systems may already provide with UID
 * generation of any client side object, in our case this could be generated by the data layer in
 * place of a database id if we still need some form of conflict resolution that is.
 *
 * @param {ObjectIdGenerator} generator
 */
export var setPrimaryObjectIdGenerator = function (generator) {
    assert(typeof generator === 'function' || generator === null, 'Invalid type given should be a function or null');
    objectIdGenerationState.primaryObjectIdGenerator = generator;
};
//# sourceMappingURL=setPrimaryObjectIdGenerator.js.map